'use client'

import { ColumnDef } from '@tanstack/react-table'
import { CustomerAccount } from '../types'
import { CustomerAccountActions } from './CustomerAccountActions'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Mail } from 'lucide-react'
import { useMutation } from '@apollo/client'
import { CUSTOMER_ACCOUNT_SEND_INVITATION } from '../customerAccountQueries'
import { toast } from 'sonner'

export const columns: ColumnDef<CustomerAccount>[] = [
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row }) => {
      return <div className="font-medium">{row.getValue('email')}</div>
    },
  },
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => {
      const name = row.getValue('name') as string
      return <div>{name || '-'}</div>
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const status = row.getValue('status') as string
      const [sendInvitation, { loading }] = useMutation(
        CUSTOMER_ACCOUNT_SEND_INVITATION
      )

      const handleSendInvitation = async () => {
        try {
          await sendInvitation({
            variables: { id: row.original.id },
          })
          toast.success('Invitation sent successfully')
        } catch (error) {
          console.error('Failed to send invitation:', error)
          toast.error('Failed to send invitation')
        }
      }

      return (
        <div className="flex items-center gap-2">
          <Badge
            variant={status === 'NEW' ? 'secondary' : 'default'}
            className="whitespace-nowrap"
          >
            {status || 'ACTIVE'}
          </Badge>
          {status === 'NEW' && (
            <Button
              size="sm"
              variant="outline"
              onClick={handleSendInvitation}
              disabled={loading}
              className="h-6 w-6 p-0"
            >
              <Mail className="h-3 w-3" />
            </Button>
          )}
        </div>
      )
    },
  },
  {
    accessorKey: 'createdAt',
    header: 'Created',
    cell: ({ row }) => {
      const date = new Date(row.getValue('createdAt'))
      return <div>{date.toLocaleDateString()}</div>
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => {
      return <CustomerAccountActions customerAccount={row.original} />
    },
  },
]
